import { useState } from 'react'
import Date from '../../../../Core/Fields/Floating/Date';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectInput from '../../../../Core/Fields/SelectInput';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab1 = ({ selectedSupplier, supplirGrpname, selectedpayment, isGroup }) => {

  return (
    <div>
      <div className="px-4 py-4" style={{ background: 'white' }}>
        <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >
          <div className="col-md-12" style={{ display: 'flex' }} >

            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                   <Input
            id="SupplierGroupName"
            label="Supplier Group Name"
            style={{ height: "30px",border: supplirGrpname.Error ? "1px solid red" : "", }}
            value={supplirGrpname.value}
            onChange={(e) => supplirGrpname.setValue(e.target.value)}
          />
                  
                </div>
                <div style={{ flex: 1 }}>
                    <SelectSearch
              list={selectedSupplier.supplier}
              style={{
                height: "30px",
                border: selectedSupplier.Error ? "1px solid red" : "",
              }}
              label="Parent Supplier Group"
              getOptionLabel={(item) => item.name}
                    getOptionValue={(item) => item.name}
              value={selectedSupplier.value}
              onChange={(val) => selectedSupplier.setValue(val)}
            />
                 
                </div>
                <div style={{ flex: 1 }}>
                  <SelectSearch
                    list={selectedpayment.payment}
                    style={{
                height: "30px",
                border: selectedpayment.Error ? "1px solid red" : "",
              }}
                    label="Default Payment Terms Template"
                     getOptionLabel={(item) => item.name}
                    getOptionValue={(item) => item.name}
              value={selectedpayment.value}
              onChange={(val) => selectedpayment.setValue(val)}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ height: '19px' }}></label>
                  <Checkbox
                    id="isGroup"
                    label="is Group"
                   value={isGroup?.value || false}
            onChange={(val) => isGroup?.setValue?.(val)}
                  />

                </div>
              </div>


            </div>


          </div>
        </div>


      </div>

    </div>
  )
}

export default Tab1